if ($("body").hasClass("template-product")) {
  
  $('.metafields-diametro').each(function(i, obj) {
    var str = $(this).first().text();

    var number = $(this).text();
    $(this).attr("data-order",number);

  });


  /***
  SORT METAFIELDS
  ***/

  setTimeout(function(){

    var $sorted_items,
      getSorted = function(selector, attrName) {
          return $(
            $(selector).toArray().sort(function(a, b){
                var aVal = parseInt(a.getAttribute(attrName)),
                    bVal = parseInt(b.getAttribute(attrName));

                return aVal - bVal;
            })
          );
      };

    $sorted_items = getSorted('#starting_divs .item', 'data-order').clone();

    $('#after_sorting').html( $sorted_items );

  }, 1500); //1.5 seconds
  
}

if ($("body").hasClass("template-suffix-artusi-2-0")) {
  var is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (is_safari) {
    $(".template-suffix-artusi-2-0 .reading-width").css("max-width","600px");
  }
}


/***
FOOTER - ADD ACCORDION TO MENU BLOCK IN MOBILE
***/

if (screen.width <= 650) {
  $('.section-footer__menu-block .section-footer__title').addClass("accordion");
  $('.section-footer__menu-block .section-footer__menu-block__menu').addClass("panel");
}

$( window ).resize(function() {
  if (screen.width <= 650) {
    $('.section-footer__menu-block .section-footer__title').addClass("accordion");
    $('.section-footer__menu-block .section-footer__menu-block__menu').addClass("panel");
  } else {
    $('.section-footer__menu-block .section-footer__title').removeClass("accordion");
    $('.section-footer__menu-block .section-footer__menu-block__menu').removeClass("panel");    
  }
});

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function(){
    this.classList.toggle("active");
    this.nextElementSibling.classList.toggle("show");
  }
}


/***
MARKET OLANDA
***/

setTimeout(() => {
  if (document.getElementsByClassName("recommendation-modal__message").length > 0) {
    var text = document.getElementsByClassName("recommendation-modal__message")[0].innerHTML;
    let checkCountry = text.includes("Netherlands");
    console.log(checkCountry);
    if(checkCountry == true) {
      console.log("checkCountry is true");
      var replace = text.replace('ships to', 'is available in ');
      document.getElementsByClassName("recommendation-modal__message")[0].setAttribute("id","text-to-change");
      document.getElementById("text-to-change").innerHTML = "";
      document.getElementById("text-to-change").insertAdjacentHTML('beforeend',replace);
      document.getElementsByClassName("recommendation-modal__container")[0].style.display="inline";
    } else {
      console.log("checkCountry is false");
      document.getElementsByClassName("recommendation-modal__container")[0].style.display="inline";
      if (document.querySelectorAll(".recommendation-modal__container li:nth-child(2)")[0] !== undefined) {
        document.querySelectorAll(".recommendation-modal__container li:nth-child(2)")[0].style.display="flow-root list-item";
      }
    }
  }
}, "2500");


/***
ALREADY SUBSCRIBED MESSAGE WHEN USER SUBSCRIBE TO NEWSLETTER
***/
var live_url = window.location.href;
var result = live_url.includes('form_type=customer');
var input_val = document.getElementsByName('contact[email]')
if(result && input_val != 0){
    const add_ele = document.createElement("h3");
    add_ele.innerText = "Risulti già iscritto";
    document.querySelector('div.signup-form').appendChild(add_ele);
    add_ele.classList.add('newsletter_already_subscribed','newsletter-form__message','form__message'); 
   document.getElementById("shopify-section-template--15952362635425__83695ecc-453e-4ecd-9745-43ea4efb5009").style.setProperty('display', 'block', 'important');
}


 /*================ Components ================*/
  var CCFetchedContent = class extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;

          if (this.hasAttribute('contains-product-blocks')) {
            var swiperCont = this.querySelector('.swiper-container');
            if (swiperCont) {
              theme.initProductSlider($(swiperCont));
            }
          }
        }
      });
    }
  };
  window.customElements.define('cc-fetched-content', CCFetchedContent);
  ;
document.addEventListener('DOMContentLoaded', function () {
   var contactButton = document.getElementById('contact-button');

   if (contactButton) {
      contactButton.addEventListener('click', function () {
         var customerServiceEmail = 'customerservice@example.com';
         var subject = 'Richiesta di assistenza';
         var body = 'Ciao Customer Service, vorrei chiedere...';

         var mailtoLink = 'mailto:' + customerServiceEmail +
            '?subject=' + encodeURIComponent(subject) +
            '&body=' + encodeURIComponent(body);

         window.location.href = mailtoLink;
      });
   }
});
